export enum CommercialOrderStatus {
    PendingSampleReception = 'PendingSampleReception',
    OrderPlaced = 'OrderPlaced',
    SampleReceivedAtLab = 'SampleReceivedAtLab',
    KitSentToPatient = 'KitSentToPatient',
    SampleCollected = 'SampleCollected',
    MobileDrawSchedulePending = 'MobileDrawSchedulePending',
    ThirdPartyDrawPending = 'ThirdPartyDrawPending',
    TestInProgress = 'TestInProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    PendingRelease = 'PendingRelease',
    PendingReleaseFinalOrder = 'PendingReleaseFinalOrder',
}